import { BrowserStorage } from '@atc/browser-storage';

/**
 * UserProfileCache
 *
 * firstName: {String}
 * thumbnailUrl: {String}
 * carIds: [Array]
 * searchIds: [Array]
 *
 * @typedef {Object} cacheEvent
 * @property {String} action
 * @property {String} cacheType
 * @property {String} id
 */

export const rootKey = 'ATC_USER_PROFILE';

/**
 * Handles storing and caching personalization locally without authentication
 * @module UserProfileCache
 */
export default class UserProfileCache {
  constructor() {
    this.storage = new BrowserStorage(rootKey, {
      persist: true
    });
  }

  /**
   * @alias module:UserProfileCache
   * @returns {boolean}
   */
  isReady() {
    return !!this.storage.options.storage[rootKey];
  }

  /**
   * @alias module:UserProfileCache
   * @return {this}
   */
  clearItem() {
    this.storage.removeItem();
    return this;
  }

  /**
   * @alias module:UserProfileCache
   * @return {Object}
   */
  getItem() {
    return this.storage.getItem() || {};
  }

  /**
   *
   * @param data
   * @returns {{action: string, data: {}}}
   */
  updateItems(data) {
    if (data === void 0) {
      data = {};
    }
    const profile = this.getItem();
    this.storage.setItem({
      ...profile,
      ...data
    });
    return {
      action: 'update',
      data: this.getItem()
    };
  }

  /**
   * @alias module:UserProfileCache
   * @return {cacheEvent}
   */
  removeItems(items) {
    if (items === void 0) {
      items = [];
    }
    const profile = this.getItem();
    items.forEach(key => delete profile[key]);
    this.storage.setItem(profile);
    return {
      action: 'remove',
      data: this.getItem()
    };
  }

  /**
   * Replace any current cached items with a new set
   * @alias module:UserProfileCache
   * @param {Object}
   * @return {this}
   */
  setItem(items) {
    if (items === void 0) {
      items = {};
    }
    this.storage.setItem(items);
    return this;
  }
}